export default __webpack_public_path__ + "Coverage2.csv";